import type { UseQueryOptions, UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';

import { apiClient } from 'api/apiClient';
import type { IRequestException } from 'api/types/requestException';
import type { IUserProfile } from 'api/types/user';

export interface IUpdateUserProps
    extends UseQueryOptions<IUserProfile, IRequestException> {
    data: Partial<IUserProfile> & { password?: string };
}

export const updateUser = async ({ data }: IUpdateUserProps) => {
    const response = await apiClient.patch('users/me', {
        json: {
            ...data,
        },
    });
    return (await response.json()) as IUserProfile;
};

export const useUpdateUserMutation = (
    options: UseMutationOptions<
        IUserProfile,
        IRequestException,
        IUpdateUserProps
    >
) => {
    return useMutation<IUserProfile, IRequestException, IUpdateUserProps>(
        'user',
        async (data) => await updateUser(data),
        options
    );
};
